import React from "react";
import type { PreviewMode } from "../types";

interface PreviewToggleProps {
  value: PreviewMode;
  onChange: (mode: PreviewMode) => void;
}

const PreviewToggle: React.FC<PreviewToggleProps> = ({ value, onChange }) => {
  const handleToggle = (mode: PreviewMode) => {
    // Toggle off if already selected
    onChange(value === mode ? "none" : mode);
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="text-[10px] text-gray-400 font-semibold uppercase tracking-wider">Preview</div>
      <div className="flex gap-1">
        <button
          onClick={() => handleToggle("shortest")}
          className={`flex-1 py-1.5 text-[10px] font-semibold rounded-md transition-all duration-200 ${
            value === "shortest"
              ? "bg-indigo-100 text-indigo-700 outline outline-1 outline-indigo-300"
              : "bg-gray-100 text-gray-500 hover:bg-gray-200"
          }`}
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Shortest
        </button>
        <button
          onClick={() => handleToggle("longest")}
          className={`flex-1 py-1.5 text-[10px] font-semibold rounded-md transition-all duration-200 ${
            value === "longest"
              ? "bg-indigo-100 text-indigo-700 outline outline-1 outline-indigo-300"
              : "bg-gray-100 text-gray-500 hover:bg-gray-200"
          }`}
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Longest
        </button>
      </div>
    </div>
  );
};

export default PreviewToggle;
